import request from '../../axios/axiosconfig.js'

export function getAllPcCapitalDetail(params) {
  return request({
    url: '/ps/pcCapitalDetail/getAllPcCapitalDetail',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/accountFunds/psfundsdetail.js